// extracted by mini-css-extract-plugin
export default {"list":"EpisodesList_list__ZqQlU","fadein":"EpisodesList_fadein__Hu8eC"};